import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMobileBlackList, setMobileBlackList } from '../api/index.js';
import { getMobileBlackList as getKefuMobileBlackList } from '@/views/serviceCenter/api/index.js';
export default {
  name: 'NotTicketPhoneBlacklist',
  props: {
    customer_id: {
      type: [String, Number],
      default: ''
    },
    customer_account_id: {
      type: [String, Number],
      default: ''
    },
    // 只读模式：隐藏添加/删除/保存，仅查看列表（客服工作台 marketSet 复用）
    readonly: {
      type: Boolean,
      default: false
    },
    // 接口前缀模块：customer（客户配置中心）| service_custom / plat_service_custom（客服工作台）
    module: {
      type: String,
      default: 'customer'
    }
  },
  data: function data() {
    return {
      isShow: false,
      phoneInput: '',
      // 草稿列表：[{ mobile, create_time }]
      list: [],
      // 当前勾选行快照（用于底部全选态联动）
      selection: [],
      // 添加结果：{ type, text }
      addResult: null
    };
  },
  computed: {
    isAllSelected: function isAllSelected() {
      return this.list.length > 0 && this.selection.length === this.list.length;
    }
  },
  methods: {
    // 对外接口：拉取黑名单列表（父级打开弹窗后调用）
    getList: function getList() {
      var _this = this;
      if (!this.customer_account_id) return;
      var params = {
        customer_account_id: this.customer_account_id
      };
      // 客服只读视图走 /kefu、/plat-service 前缀接口
      if (this.readonly) {
        getKefuMobileBlackList(this.module, params).then(function (res) {
          _this.initData(res.data && res.data.black_mobiles || []);
        });
      } else {
        getMobileBlackList(params).then(function (res) {
          _this.initData(res.data && res.data.black_mobiles || []);
        });
      }
    },
    // 数据初始化：标准化结构、保留后端返回顺序、重置草稿状态
    initData: function initData() {
      var mobileList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // 接口数据保持后端数组顺序展示：赋递减的负排序键（-index），降序排列后顺序与后端一致，
      // 且恒小于新添加行的毫秒时间戳，保证新添加的始终在接口数据之前
      this.list = (mobileList || []).map(function (item, index) {
        return {
          mobile: item.mobile,
          // 后端返回已格式化的时间字符串，直接展示
          create_time: item.create_time,
          sort_key: -index
        };
      });
      this.sortList();
      this.phoneInput = '';
      this.selection = [];
      this.addResult = null;
    },
    // 添加手机号：支持半角/全角逗号、空格混用分隔
    addPhones: function addPhones() {
      var _this2 = this;
      var input = (this.phoneInput || '').trim();
      if (!input) {
        this.$message.warning('请输入手机号');
        return;
      }
      var candidates = input.split(/[,，\s]+/).filter(Boolean);
      var success = 0;
      var skipped = 0;
      var error = 0;
      // 同批次按输入顺序递增赋时：先输入的视为先添加（时间更早）
      var baseTime = Date.now();
      candidates.forEach(function (phone, index) {
        if (!/^1\d{10}$/.test(phone)) {
          error++;
        } else if (_this2.list.some(function (item) {
          return item.mobile === phone;
        })) {
          // 已存在（含同批次重复）
          skipped++;
        } else {
          _this2.list.push({
            mobile: phone,
            create_time: _this2.formatTime(baseTime + index),
            sort_key: baseTime + index
          });
          success++;
        }
      });
      this.addResult = {
        type: skipped === 0 && error === 0 ? 'success' : 'error',
        text: "\u6210\u529F\u6DFB\u52A0 ".concat(success, " \u4E2A\u3001\u5DF2\u5B58\u5728\u8DF3\u8FC7 ").concat(skipped, " \u4E2A\u3001\u683C\u5F0F\u9519\u8BEF ").concat(error, " \u4E2A")
      };
      if (success > 0) {
        this.sortList();
        this.phoneInput = '';
      }
    },
    // 按排序键降序（最新在最上；create_time 为展示用的格式化字符串，不参与排序）
    sortList: function sortList() {
      this.list.sort(function (a, b) {
        return b.sort_key - a.sort_key;
      });
    },
    // 新添加行的时间展示格式（与接口返回格式对齐：YYYY-MM-DD HH:mm:ss）
    formatTime: function formatTime(timestamp) {
      var date = new Date(timestamp);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    },
    // 列表勾选变化（单选/表头全选）→ 同步快照
    syncSelection: function syncSelection(selection) {
      this.selection = selection;
    },
    // 底部全选 ↔ 表头全选联动
    toggleAll: function toggleAll(val) {
      var _this3 = this;
      if (val) {
        this.list.forEach(function (row) {
          _this3.$refs.table.toggleRowSelection(row, true);
        });
        // toggleRowSelection 为程序式调用，不会触发 select 事件，需手动同步快照
        this.selection = _toConsumableArray(this.list);
      } else {
        this.$refs.table.clearSelection();
        this.selection = [];
      }
    },
    removeRow: function removeRow(row) {
      var _this4 = this;
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var index = _this4.list.findIndex(function (item) {
          return item.mobile === row.mobile;
        });
        if (index > -1) {
          _this4.list.splice(index, 1);
        }
        _this4.$message.success('已删除 1 个手机号');
        _this4.syncSelectionAfterRemove();
      }).catch(function () {});
    },
    removeChecked: function removeChecked() {
      var _this5 = this;
      if (!this.selection.length) {
        this.$message.warning('请先勾选要删除的手机号');
        return;
      }
      var count = this.selection.length;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u9009\u4E2D\u7684 ".concat(count, " \u4E2A\u624B\u673A\u53F7\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var checkedMobiles = _this5.selection.map(function (item) {
          return item.mobile;
        });
        _this5.list = _this5.list.filter(function (item) {
          return !checkedMobiles.includes(item.mobile);
        });
        _this5.$message.success("\u5DF2\u5220\u9664 ".concat(count, " \u4E2A\u624B\u673A\u53F7"));
        _this5.syncSelectionAfterRemove();
      }).catch(function () {});
    },
    // 删除后清空勾选快照，并重置添加结果提示
    syncSelectionAfterRemove: function syncSelectionAfterRemove() {
      var _this6 = this;
      this.selection = [];
      this.addResult = null;
      this.$nextTick(function () {
        _this6.$refs.table && _this6.$refs.table.clearSelection();
      });
    },
    handleClose: function handleClose() {
      // 取消即丢弃本次全部草稿改动，直接关闭
      this.isShow = false;
    },
    // 保存：全量提交列表中的手机号
    handleSave: function handleSave() {
      var _this7 = this;
      setMobileBlackList({
        customer_id: this.customer_id,
        customer_account_id: this.customer_account_id,
        mobiles: this.list.map(function (item) {
          return item.mobile;
        }).join(',')
      }).then(function () {
        _this7.$emit('save-success');
        _this7.$message.success('保存成功！');
        // 2 秒后关闭弹窗，并通知父级刷新数据
        setTimeout(function () {
          _this7.isShow = false;
        }, 2000);
      });
    }
  }
};